import React from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import dragPreviewUrl from 'images/drag_preview.png';
import * as actions from '../../../actions/pathBuilder/contents';
import * as selectors from '../../../selectors/pathBuilder';
import Controls from './Controls';
import DragSource from './DragSource';

const ContentWrapper = ({
  id,
  type,
  showStep,
  stepNumber,
  reorder,
  children,
  noTrackLine,
  editingMode,
  connectDragSource,
  connectDragPreview,
  isDragging,
}) => {
  const wrapperClassName = classNames('PathContentWrapper', {
    'PathContentWrapper--noStep': !showStep,
    'PathContentWrapper--noTrackLine': noTrackLine,
    'PathContentWrapper--dragging': isDragging,
  });

  function setDragPreview(node) {
    if (node) {
      const dragPreview = new Image();
      dragPreview.src = dragPreviewUrl;
      dragPreview.onload = () =>
        connectDragPreview(dragPreview, { anchorX: 1, anchorY: 0 });
    }
  }

  return (
    <div className={wrapperClassName} ref={setDragPreview}>
      {children}
      {showStep && <div className="PathContentStep">{stepNumber}</div>}
      {editingMode && (
        <Controls {...{ reorder, connectDragSource }} key={type + id} />
      )}
    </div>
  );
};

ContentWrapper.defaultProps = {
  showStep: true,
};

const mapStateToProps = () => {
  const hasNoTrackLine = selectors.hasNoTrackLine();
  return (state, props) => ({
    editingMode: selectors.modeSelectors.isEdit(state.pathBuilder),
    noTrackLine: hasNoTrackLine(state.pathBuilder, props),
  });
};

const mapDispatchToProps = (dispatch, { position }) => ({
  toggleDragging: () => dispatch(actions.toggleDraggingContent()),
  reorder: newPosition => dispatch(actions.reorder(position, newPosition)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  DragSource,
)(ContentWrapper);
